import { render, staticRenderFns } from "./bankGroupManage.vue?vue&type=template&id=6f85fb71&scoped=true"
import script from "./bankGroupManage.vue?vue&type=script&lang=js"
export * from "./bankGroupManage.vue?vue&type=script&lang=js"
import style0 from "./bankGroupManage.vue?vue&type=style&index=0&id=6f85fb71&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f85fb71",
  null
  
)

export default component.exports